import FloatingParticles from '../../components/base/FloatingParticles';
import LuxuryHeroSection from './components/LuxuryHeroSection';
import LuxuryStatsSection from './components/LuxuryStatsSection';
import LuxuryServicesSection from './components/LuxuryServicesSection';
import LuxurySkillsSection from './components/LuxurySkillsSection';
import LuxuryPortfolioSection from './components/LuxuryPortfolioSection';
import LuxuryTestimonialsSection from './components/LuxuryTestimonialsSection';
import LuxuryContactSection from './components/LuxuryContactSection';

export default function HomePage() {
  return (
    <div className="relative">
      <FloatingParticles />
      <LuxuryHeroSection />
      <LuxuryStatsSection />
      <LuxuryServicesSection />
      <LuxurySkillsSection />
      <LuxuryPortfolioSection />
      <LuxuryTestimonialsSection />
      <LuxuryContactSection />
    </div>
  );
}
